var _rect, _text, _text2, _rect2, _rect3, _rect4, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVgSchool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 60,
    rx: 8,
    fill: "#7C3AED"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 25,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "white"
  }, "VG")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 40,
    fontFamily: "Arial, sans-serif",
    fontSize: 8,
    textAnchor: "middle",
    fill: "white"
  }, "SCHOOL")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 15,
    height: 10,
    fill: "white",
    opacity: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 11,
    height: 6,
    fill: "#7C3AED"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 15,
    width: 15,
    height: 10,
    fill: "white",
    opacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 20,
    r: 2,
    fill: "#7C3AED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVgSchool);
export default __webpack_public_path__ + "static/media/vg-school.a7dafbfb43d92214cfa6fbcfb9b270e5.svg";
export { ForwardRef as ReactComponent };